import React, { useState } from "react"
import { Text, View, Image, StyleSheet } from 'react-native';
import { addFontFamilylato, getImagePath } from "../../utils/services/CommonUtils";

import { CommonCTA, PrimaryCTA } from "../../utils/widgets/CommonCTA";

import AppTheme from "../../AppTheme";
import OmsStyles from "../../OmsStyle";
import disableScroll from 'disable-scroll';

import SupportViewModal from "../../utils/modals/SupportViewModal";

const PaymentSuccessOrFailed = (props) => {

    const isPaymentSuccess = props.route.params?.isPaymentSuccess;

    const [supportModal, setSupportModal] = useState(false)

    const showSupportModal = () => {
        // disableScroll.on()
        setSupportModal(true)
    }

    const closeSuportModal = () => {
        disableScroll.off()
        setSupportModal(false)
    }

    return (
        <View style={{
            height: '100vh',
            width: AppTheme.appWidth,
            justifyContent: "center",
            backgroundColor: isPaymentSuccess ? 'rgba(32, 198, 166, 1)' : 'white'
        }}>

            {
                isPaymentSuccess ? <View style={styles.flexView}>
                    <Image source={{ uri: getImagePath(`/images/icons/payment_success.svg`), width: 70, height: 70 }} />
                    <Text style={[OmsStyles.text20xb, { color: 'white', paddingTop: 24 }]}>Payment Successful</Text>

                    <View style={{ left: 16, position: "absolute", bottom: 16 }}>
                        <CommonCTA
                            text='Track Order'
                            textColor={AppTheme.color.cyan.bg}
                            width={AppTheme.appWidth - 32}
                            onPress={() => {
                                props.navigation.pop();
                                props.route.params?.RedirectOnPaymentSuccess();
                            }} />
                    </View>
                </View> : <View style={styles.flexView}>
                    <Image source={{ uri: getImagePath(`/images/icons/failed_payment.svg`), width: 70, height: 70 }} />
                    <Text style={[OmsStyles.text20xb, { paddingTop: 24 }]}>Payment Failed</Text>
                    <Text style={[OmsStyles.text16, { margin: 16, textAlign: 'center', color: 'rgba(0, 0, 0, 0.6)' }]}>
                        The amount deducted from your account will be refunded within 5-7 working days.</Text>

                    <View style={{ left: 16, position: "absolute", bottom: 16, display: 'flex', flexDirection: 'row' }}>
                        <CommonCTA
                            text='Get Help'
                            color={AppTheme.color.primary}
                            width={(AppTheme.appWidth / 2) - 24}
                            onPress={() => showSupportModal()} />
                        <View style={{ paddingLeft: 16 }}>
                            <PrimaryCTA
                                text={'Try Again'}
                                width={(AppTheme.appWidth / 2) - 24}
                                onPress={() => {
                                    props.navigation.pop(); global.appHandledBackpress = true; props.navigation.pop();
                                }} />
                        </View>
                    </View>
                </View>
            }

            <SupportViewModal showPopup={supportModal}
                closeModal={closeSuportModal} />

        </View>
    )
}

export default PaymentSuccessOrFailed;

const styles = StyleSheet.create(addFontFamilylato({
    flexView: { display: 'flex', height: '100vh', width: AppTheme.appWidth, justifyContent: "center", alignItems: 'center', alignContent: 'center' }

}))
